import React, { useState } from 'react';
import axios from 'axios';
import {
    Card,
    Input,
    Checkbox,
    Button,
    Typography,
} from "@material-tailwind/react";

export function SignIn({bgImage, logoImage}) {
    const imageUrl = bgImage;

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    function getCsrfToken() {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : null;
    }

    const csrfToken = getCsrfToken();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await axios.post('login', {
                user: { username, password },
            }, {
                headers: {
                    'Content-Type': 'application/json' },
                withCredentials: true
            });

            if (response.status === 200) {
                window.location.href = '/dashboard';
            }
        } catch (err) {
            setError('Error al iniciar sesión. Verifica tus credenciales.');
        }
    };

    return (
        <section className="m-4 lg:m-8 flex gap-4 min-h-screen-75">
            <div className="w-2/5 min-h-screen pb-20 relative hidden lg:block overflow-hidden">
                <img
                    src={imageUrl}
                    className="h-full w-full object-cover rounded-3xl"
                    style={{objectFit: "cover"}}
                />
                <div className="absolute transform bg-white/50 bg-opacity-50 p-4 shadow-lg transition-all duration-300 ease-in-out"
                    style={{height: '100%', width: '100%', top:0}}>
                    <img
                        src={logoImage}
                        className="absolute left-1/2 transform -translate-x-1/2 top-210-px w-3/4"
                    />
                </div>
            </div>


            <div className="w-full lg:w-3/5 mt-12 lg:mt-24">
                <div className="text-center">
                    <Typography variant="h2" className="font-bold mb-4">Iniciar sesión</Typography>
                    <Typography variant="paragraph" color="blue-gray" className="text-lg font-normal">Ingresa tu usuario
                        y contraseña para Iniciar Sesión.</Typography>
                </div>
                <form className="mt-8 mb-2 mx-auto w-full max-w-xs px-2 sm:px-0 lg:w-1/2 lg:max-w-screen-lg">
                    <div className="mb-1 flex flex-col gap-6">
                        <Typography variant="small" color="blue-gray" className="-mb-3 font-medium">
                            Usuario
                        </Typography>
                        <Input
                            size="lg"
                            placeholder="usuario"
                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                            labelProps={{
                                className: "before:content-none after:content-none",
                            }}
                            onChange={(e) => setUsername(e.target.value)}
                            value={username}
                        />
                        <Typography variant="small" color="blue-gray" className="-mb-3 font-medium">
                            Contraseña
                        </Typography>
                        <Input
                            type="password"
                            size="lg"
                            placeholder="********"
                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                            labelProps={{
                                className: "before:content-none after:content-none",
                            }}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    {/*<Checkbox
                        label={
                            <Typography
                                variant="small"
                                color="gray"
                                className="flex items-center justify-start font-medium"
                            >
                                Acepto los&nbsp;
                                <a
                                    href="#"
                                    className="font-normal text-black transition-colors hover:text-gray-900 underline"
                                >
                                    Terminos y Condiciones
                                </a>
                            </Typography>
                        }
                        containerProps={{className: "-ml-2.5"}}
                    />*/}

                    {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                    <Button className="mt-6" fullWidth onClick={handleLogin}>
                        Iniciar Sesión
                    </Button>

                    <div className="flex items-center justify-center gap-2 mt-6">
                        {/*<Checkbox
                            label={
                                <Typography
                                    variant="small"
                                    color="gray"
                                    className="flex items-center justify-start font-medium"
                                >
                                    Subscribe me to newsletter
                                </Typography>
                            }
                            containerProps={{ className: "-ml-2.5" }}
                        />*/}
                        <Typography variant="small" className="font-medium text-gray-900">
                            <a href="#">
                                Olvidé mi contraseña
                            </a>
                        </Typography>
                    </div>
                    {/*<div className="space-y-4 mt-8">
                        <Button size="lg" color="white" className="flex items-center gap-2 justify-center shadow-md" fullWidth>
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1156_824)">
                                    <path d="M16.3442 8.18429C16.3442 7.64047 16.3001 7.09371 16.206 6.55872H8.66016V9.63937H12.9813C12.802 10.6329 12.2258 11.5119 11.3822 12.0704V14.0693H13.9602C15.4741 12.6759 16.3442 10.6182 16.3442 8.18429Z" fill="#4285F4" />
                                    <path d="M8.65974 16.0006C10.8174 16.0006 12.637 15.2922 13.9627 14.0693L11.3847 12.0704C10.6675 12.5584 9.7415 12.8347 8.66268 12.8347C6.5756 12.8347 4.80598 11.4266 4.17104 9.53357H1.51074V11.5942C2.86882 14.2956 5.63494 16.0006 8.65974 16.0006Z" fill="#34A853" />
                                    <path d="M4.16852 9.53356C3.83341 8.53999 3.83341 7.46411 4.16852 6.47054V4.40991H1.51116C0.376489 6.67043 0.376489 9.33367 1.51116 11.5942L4.16852 9.53356Z" fill="#FBBC04" />
                                    <path d="M8.65974 3.16644C9.80029 3.1488 10.9026 3.57798 11.7286 4.36578L14.0127 2.08174C12.5664 0.72367 10.6469 -0.0229773 8.65974 0.000539111C5.63494 0.000539111 2.86882 1.70548 1.51074 4.40987L4.1681 6.4705C4.8001 4.57449 6.57266 3.16644 8.65974 3.16644Z" fill="#EA4335" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1156_824">
                                        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span>Sign in With Google</span>
                        </Button>
                        <Button size="lg" color="white" className="flex items-center gap-2 justify-center shadow-md" fullWidth>
                            <img src="/img/twitter-logo.svg" height={24} width={24} alt="" />
                            <span>Sign in With Twitter</span>
                        </Button>
                    </div>
                    <Typography variant="paragraph" className="text-center text-blue-gray-500 font-medium mt-4">
                        Not registered?
                        <a href="/ux/sign-up" className="text-gray-900 ml-1">Create account</a>
                    </Typography>*/}
                </form>

            </div>

        </section>
    );
}

export default SignIn;
